import {
  type BillingStateQuery,
  SupplierBillingStateSaleStatus,
} from "~/graphql/graphql-new.gen";

type InvoiceLockState = Pick<
  BillingStateQuery["supplierBillingState"],
  | "isPendingClaimClosing"
  | "isPendingOrderDelivery"
  | "isPendingReturnValidation"
  | "isPendingWithdrawalPeriod"
  | "saleStatus"
>;

export const getInvoiceLockReason = (billingState: InvoiceLockState) => {
  if (billingState.saleStatus === SupplierBillingStateSaleStatus.Upcoming) {
    return "sale-upcoming";
  }

  if (billingState.saleStatus === SupplierBillingStateSaleStatus.Ongoing) {
    return "sale-ongoing";
  }

  if (
    billingState.isPendingClaimClosing ||
    billingState.isPendingOrderDelivery ||
    billingState.isPendingReturnValidation
  ) {
    return "pending-actions";
  }

  return billingState.isPendingWithdrawalPeriod
    ? "waiting-withdrawal"
    : "default";
};

export const getIsInvoiceReady = (
  billingState: BillingStateQuery["supplierBillingState"] | undefined,
) => {
  if (!billingState) return false;

  return billingState.canAccess || billingState.canAccessBypassed;
};
